import React, {Component} from "react";
import {Button, Form, Input, message} from "antd";
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl-context";
import {getUserTeamList} from "../../../modules/team/action";
const FormItem = Form.Item;

class SearchTeamByUserIdFilter extends Component {

    constructor(props) {
        super(props);
        this.state = {userTeamsData:[],isShowUserTeamsData: false}
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
    }

    handleSubmit(e) {
        e.preventDefault();
        let _self = this;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if(values.gamerShowId){
                    _self.getUserTeamList(values.gamerShowId);
                }else{
                    message.warning('请输入用户展示ID');
                }
            }
        });
    }

    getUserTeamList = async (values) =>{
        const {getUserTeamList} = this.props;
        await getUserTeamList(values);
        await this.setUserTeamsData();

    }

    setUserTeamsData = () =>{
        const {userTeams} = this.props;
        this.setState({
            userTeamsData: userTeams.map(function (v) {
                return v.gameType+"-"+v.teamShowId
            }).join(','),
            isShowUserTeamsData: true
        })
    }

    onChangeGamerShowId = () => {
        this.setState({
            userTeamsData: [],
            isShowUserTeamsData: false
        })
    }


    render() {
        const {getFieldDecorator} = this.props.form;
        const {isShowUserTeamsData,userTeamsData} = this.state;
        return (
            <div>
                <Form onSubmit={this.handleSubmit} layout="inline" style={{display: 'inline'}}>
                    <FormItem label="用户展示Id">
                        {getFieldDecorator('gamerShowId', {
                                rules: [{pattern: /^[1-9][0-9]*$/, message: '请输入正确格式!'}],
                            }
                        )(
                            <Input style={{width: '150px'}} allowClear onChange={this.onChangeGamerShowId}/>
                        )}
                    </FormItem>
                    <FormItem>
                        <Button type="primary" htmlType="submit" style={{width: '100%'}}>
                            查询
                        </Button>
                    </FormItem>
                </Form>
                {isShowUserTeamsData ? <div style={{display: 'inline', lineHeight: '41px'}}>战队展示ID : {userTeamsData.length>0 ? userTeamsData : '无'}</div> : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.Team,
    }
};
const mapDispatchToProps = ({getUserTeamList});
export default connect(
    mapStateToProps, mapDispatchToProps,
)(injectIntl(Form.create()(SearchTeamByUserIdFilter)));